import AuthorizationForm, {AuthorizationFormOptions} from "./AuthorizationForm";

export default function(options: AuthorizationFormOptions) {
    return this.each(function() {
        let instance = new AuthorizationForm(this, options);
        instance.initialize();
        $.data(this, 'authorizationForm', instance);
    });
}